/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Search_TitleInputs */

const en_directory_tools_search_title = /** @type {(inputs: Directory_Tools_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the directory`)
};

const zh_directory_tools_search_title = /** @type {(inputs: Directory_Tools_Search_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索工具库`)
};

/**
* | output |
* | --- |
* | "Search the directory" |
*
* @param {Directory_Tools_Search_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_search_title = /** @type {((inputs?: Directory_Tools_Search_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Search_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_search_title(inputs)
	return zh_directory_tools_search_title(inputs)
});
export { directory_tools_search_title as "directory.tools.search.title" }